
import { IGetMeasuresParameters } from "./IGetMeasuresParameters";


export class GetMeasuresParameters implements IGetMeasuresParameters
{
    dataSourceIds: number[] = [];
}
